import Hierarchies_CriteriaPage from "@Criteria/Hierarchies/Pages/CriteriaPage.vue";
import Hierarchies_MeasurementsPage from "@Criteria/Hierarchies/Pages/MeasurementsPage.vue";
import Hierarchies_LegacyMeasurementsPage from "@Criteria/Hierarchies/Pages/LegacyMeasurementsPage.vue";

import Weights_WeightsPage from "@Criteria/Weights/Pages/WeightsPage.vue";

import WeightedScoresPage from "@Criteria/WeightedScores/Pages/WeightedScoresPage.vue";
import CreateWeightedScorePage from "@Criteria/WeightedScores/Pages/CreateWeightedScorePage.vue";
import EditWeightedScorePage from "@Criteria/WeightedScores/Pages/EditWeightedScorePage.vue";

export const routes = [

    {
        path: "/pp/criteria-hierarchy/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_CriteriaPage,
    },
    {
        path: "/pp/measurement/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_MeasurementsPage,
    },
    {
        path: "/pp/criteria-scales/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_LegacyMeasurementsPage,
    },

    {
        path: "/pp/criteria-surveys/:workspaceId/:projectId/:evalModelId",
        component: Weights_WeightsPage,
    },


    {
        path: "/pp/weighted-scores/:workspaceId/:projectId/:evalModelId",
        component: WeightedScoresPage,
    },
    {
        path: "/pp/create-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: CreateWeightedScorePage,
    },
    {
        path: "/pp/edit-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: EditWeightedScorePage,
    },
]
